export function toCSV(data = [], columns = null) {
    const getDefaultColumns = (data) => {
        let columns = [];
        data.forEach(i => {
            if (typeof i === 'object') {
                Object.keys(i).forEach(k => {
                    if (!columns.includes(k)) {
                        columns.push(k);
                    }
                });
            }
        });
        return columns;
    }

    const getValue = (key, data) => {
        const steps = key.trim().split('.').filter(str => str.trim() !== "");
        return steps.reduce((obj, step) => {
            return (obj === null || (typeof obj !== 'object')) ?
                null : obj[step];
        }, data);
    }

    columns = (columns || getDefaultColumns(data)).filter(column => typeof column === "string" || typeof column.name === "string");
    const columnsGroup = [columns.map(column => typeof column === "string" ? column : (column?.nameGroup || ""))];

    let rows = columnsGroup.concat([columns.map(column => (typeof column === "string" ? column : column.name))])
        .concat(
            data.map(i => {
                return columns
                    .reduce((arr, key) => {
                        let v = getValue((typeof key === "string" ? key : key.dataField), i);
                        switch (typeof v) {
                            case 'object':
                            case 'symbol':
                                v = '"' + JSON.stringify(v).replace(/"/g, '\"\"') + '"';
                                break;
                            case 'undefined':
                            case 'function':
                                v = '';
                                break;
                            case 'boolean':
                                v = v.toString();
                                break;
                            case 'string':
                                v = '"' + v.toString() + '"';
                                break;
                        }
                        arr.push(v);
                        return arr;
                    }, []);
            })
        );
    let content = rows.map(r => r.join(",")).join("\n");
    content = new Blob([content], { type: "data:text\csv;charset=utf-8" });
    content = URL.createObjectURL(content);
    return content;
}